module.exports = "https://secnetweb.ksyun.com/KEC/ksc-node-kvm/assets/ionicons.621bd386841f74e0053cb8e67f8a0604.svg";